import { render, staticRenderFns } from "./CalendarPage.vue?vue&type=template&id=37153c50&"
import script from "./CalendarPage.vue?vue&type=script&lang=js&"
export * from "./CalendarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37153c50')) {
      api.createRecord('37153c50', component.options)
    } else {
      api.reload('37153c50', component.options)
    }
    module.hot.accept("./CalendarPage.vue?vue&type=template&id=37153c50&", function () {
      api.rerender('37153c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/CalendarPage.vue"
export default component.exports